<template>
  <div id="app">
    <Header></Header>
    <Menu :content="menuContent" :offer="offer" />

    <transition name="router-anim" enter-active-class="fadeIn">
      <router-view @offer="handleOffer"/>
    </transition>

    <CookieAlert v-if="cookie" @cookieStatus="cookieAlert"/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import CookieAlert from '@/components/CookieAlert.vue';

import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';

Vue.use(VueScrollTo);

export default {
  components: { CookieAlert, Header, Menu },
  data() {
    return {
      menuContent: [
        { id: 1, tag: 'about', content: 'O FIRMIE' },
        { id: 2, tag: 'offer', content: 'OFERTA' },
        { id: 3, tag: 'services', content: 'USŁUGI' },
        { id: 4, tag: 'delivery', content: 'DOSTAWA' },
        { id: 5, tag: 'contact', content: 'KONTAKT' },
        { id: 6, tag: 'partners', content: 'PARTNERZY' },
      ],
      offer: false,
      cookie: true,
    };
  },
  methods: {
    handleOffer(value) {
      this.offer = value;
    },
    cookieAlert() { this.cookie = !this.$cookies.get('agree'); },
  },
  created() { this.cookieAlert(); },
};
</script>

<style lang="scss">

  .fadeIn {
    animation-duration: 0.5s; animation-fill-mode: both;
    animation-name: fadeIn;
  }

  @keyframes fadeIn {
    from { opacity: 0 }
    to { opacity: 1 }
  }

  * { box-sizing: border-box };

  body, html {
    padding: 0; margin: 0;
    color: white; font-size: 16px;
    background-color: black;
    overflow-x: hidden;
  }

  a { color: black; text-decoration: none }

  $sticky-header-size: 50px;
  $screen-min-height: auto;

  .screen {
    min-height: $screen-min-height;
    position: relative;

    font-family: 'Quicksand', sans-serif;
    font-weight: normal;
    text-align: center;
    color: black;

    p {
      padding: 25px; margin: 0; position: relative;

      @media (min-width: 992px) { padding: 25px 150px; font-size: 1.5em }
      @media (min-width: 1200px) {
        $width: 1200px;

        width: $width;
        left: calc(50% - calc(#{$width} / 2));
        line-height: 34px;
        padding: 50px 25px;
      }
    }
  }

  #footer {
    display: flex;
    width: 100%; height: 50px;

    justify-content: center;
    align-items: center;

    font-size: 12px;
    color: #989898;
    background-color: #252525;
  }
</style>
